import Box from '@mui/material/Box';

interface PillSelectorItem {
  id: string;
  label: string;
}

interface PillSelectorProps {
  items: PillSelectorItem[];
  value: string;
  onChange: (v: string) => void;
  color?: string;
  showDot?: boolean;
}

export default function PillSelector({ items, value, onChange, color, showDot }: PillSelectorProps) {
  return (
    <Box sx={{ display: 'flex', gap: 0.5, p: 0.5, bgcolor: 'action.hover', borderRadius: '10px', width: 'fit-content' }}>
      {items.map((item) => {
        const isActive = value === item.id;
        return (
          <Box
            key={item.id}
            onClick={() => onChange(item.id)}
            sx={{
              'px': 2,
              'py': 0.75,
              'borderRadius': '8px',
              'cursor': 'pointer',
              'fontSize': '0.85rem',
              'fontWeight': 600,
              'transition': 'all 0.2s ease',
              'display': 'flex',
              'alignItems': 'center',
              'gap': 0.75,
              'bgcolor': isActive ? (color || 'primary.main') : 'transparent',
              'color': isActive ? '#fff' : 'text.secondary',
              'boxShadow': isActive ? '0 1px 4px rgba(0,0,0,0.12)' : 'none',
              'border': isActive ? 'none' : '1px solid transparent',
              '&:hover': {
                bgcolor: isActive ? (color || 'primary.main') : 'rgba(0,0,0,0.04)',
                color: isActive ? '#fff' : (color || 'text.primary'),
              },
            }}
          >
            {showDot && (
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  bgcolor: isActive ? 'rgba(255,255,255,0.7)' : 'rgba(0,115,77,0.6)',
                  flexShrink: 0,
                }}
              />
            )}
            {item.label}
          </Box>
        );
      })}
    </Box>
  );
}
